import React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import { AppProvider } from './AppContext';
import ProtectedRoute from './ProtectedRoute';

import NewApplicationPage from './component/home/NewApplicationPage';
import HomeContainer from './container/homecontainer/HomeContainer';
import CheckListContainer from './container/homecontainer/CheckListContainer';
import OtpContainer from './container/homecontainer/OtpContainer';
import Navbar from './common/Navbar';
import ThankYouPage from './component/home/ThankYouPage';
import ApplicationStatusContainer from './container/homecontainer/ApplicationStatusContainer';
import OtpCheckStatusContainer from './container/homecontainer/OtpCheckStatusContainer';
import CheckApplicationStatusContainer from './container/homecontainer/CheckApplicationStatusContainer';
import Footer from './common/Footer';
import UpdateStatusComponent from './component/home/updateStatus/UpdateStatus';
import EmailSearchComponent from './component/home/updateStatus/EmailSearchComponent';
import PasswordCheck from './component/home/updateStatus/PasswordCheck/PasswordCheck';
import ScrollToTop from './common/ScrollToTop';
import UpdatedSuccessfully from './component/home/updateStatus/UpdatedSuccessfully';

function Routing() {
    return (
        <AppProvider>
            <Router>
            
                <ScrollToTop /> {/* Always reset scroll position on route changes */}
                <Navbar />
                <Routes>
                    <Route path="/" element={<HomeContainer />} />
                    <Route
                        path="/checkList"
                        element={
                            <ProtectedRoute requiredStep={1}>
                                <CheckListContainer />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/otp"
                        element={
                            <ProtectedRoute requiredStep={2}>
                                <OtpContainer />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/newApplicationPage"
                        element={
                            <ProtectedRoute requiredStep={3}>
                                <NewApplicationPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/thankyou"
                        element={
                            <ProtectedRoute>
                                <ThankYouPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/checkApplicationStatus" element={<CheckApplicationStatusContainer />} />
                    <Route
                        path="/otpCheckStatusContainer"
                        element={
                            <ProtectedRoute requiredStep={3}>
                                <OtpCheckStatusContainer />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/applicationStatus"
                        element={
                            <ProtectedRoute requiredStep={4}>
                                <ApplicationStatusContainer />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/updatesubmissionstatus" element={<PasswordCheck />} />
                    <Route
                        path="/emailSearch"
                        element={
                            <ProtectedRoute requiredStep={7}>
                                <EmailSearchComponent />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/updateStatus"
                        element={
                            <ProtectedRoute requiredStep={8}>
                                <UpdateStatusComponent />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/updatedSuccessfully"
                        element={
                            <ProtectedRoute requiredStep={9}>
                                <UpdatedSuccessfully />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
                <Footer />
            </Router>
        </AppProvider>
    );
}

export default Routing;
